/**
 * New Listings Tips
 * 
 * @Author: Focci
 * @Date: 2024-09-11 13:37:49
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-11 13:37:49
 */

'use client'

import { useMemo, useCallback } from 'react'
import { omit } from 'lodash-es'
import { useListing } from '../../mix/context'
import useSearchHistoryRouter from '../../useSearchHistoryRouter'
import { 
  TipsForNewListingsBack, 
  TipsForNewListingsBody, 
  TipsForNewListingsWithCount 
} from './lib'

export function NewListingsTip({
  onClick,
  type = '',
  apiParam = {},
  searchParam = {},
}) {
  const { checkListTime, listTime } = searchParam

  const param = useMemo(() => (
    listTime 
      ? omit(searchParam, ['listTime', 'checkListTime'])
      : { ...omit(searchParam, ['checkListTime']), listTime: apiParam.checkListTime }
  ), [apiParam.checkListTime, listTime, searchParam])

  if(!(listTime || checkListTime)) {
    return null
  }

  return (
    <TipsForNewListingsBody
      type={type} 
      param={param} 
      onClick={onClick} 
      className={listTime ? 'my-4' : 'mt-4'}
    >
      {listTime 
        ? <TipsForNewListingsBack />
        : <TipsForNewListingsWithCount searchParam={searchParam} apiParam={apiParam} />}
    </TipsForNewListingsBody>
  )
}

/**
 * 地图列表使用
 */
export function NewListingsTipClient(props) {
  const { query } = useListing()
  const router = useSearchHistoryRouter()

  const handleClick = useCallback(({ type, param }) => {
    router.pushUrl({ type, param, query })
  }, [query, router])

  return (
    <NewListingsTip 
      onClick={handleClick}
      {...props}
    />
  )
}
